import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function FooterComponent() {
    
      return (
        <footer>
           <Container fluid>
            <Row className="row-row-col-3">
              <Col className='row-col-3'>
                <Row className='indentNull'><a className='link-light' href='https://irashin-ptz.ru'>Разработчик: Ирашин Дмитрий Андреевич</a></Row>
                <Row className='indentNull'><a className='link-light' href='/about'>Лицензия </a></Row>
                <Row className='indentNull'><a className='link-light' href='/help'>Инструкция</a></Row>
              </Col>


              <Col>
              </Col>

              <Col>
              <Row className='indentNull'><a className='link-light' href='/about'>Version 0.0.1b </a></Row>
              </Col>
            </Row>
          </Container>      
        </footer>
      )
};
export default FooterComponent;

